import { GridOptions } from '@ag-grid-community/core';

import { SITE_BUDGET_HIDDEN_COLUMNS, siteBudgetColumns } from './site-budget-column';
import { SITE_BUDGET_DEFAULT_CONFIG } from './site-budget-default-config';
import {
  SiteInvoiceablesNoRowsComponent,
  SiteInvoiceablesNoRowsParams,
} from '../components/site-invoiceables-no-rows.component';
import { SiteBudgetGridContext } from '../types/site-budget-grid-context';
import { GridRowData } from '../types/site-budget-grid-row';

export const siteBudgetConfig = (cxt: SiteBudgetGridContext): GridOptions<GridRowData> => {
  const config = SITE_BUDGET_DEFAULT_CONFIG;

  return {
    ...config,
    columnDefs: [...SITE_BUDGET_HIDDEN_COLUMNS, ...siteBudgetColumns(cxt)],
    defaultColDef: {
      ...config.defaultColDef,
      editable: cxt.editMode,
    },
    noRowsOverlayComponent: cxt.isSiteInvoiceables ? SiteInvoiceablesNoRowsComponent : undefined,
    noRowsOverlayComponentParams: <SiteInvoiceablesNoRowsParams>{
      disabled: cxt.disabled,
      onAddRow: () => {
        const DELAY_MS_AFTER_ADDING_ROW = 100;

        cxt.goToEditMode();
        cxt.addRow();

        setTimeout(() => {
          cxt.setFirstEditableCell();
        }, DELAY_MS_AFTER_ADDING_ROW);
      },
    },
    onRowSelected: (event) => {
      const { data } = event;

      if (data) {
        cxt.setSelectedRows(data, event.node.isSelected() ?? false);
      }
    },
  };
};
